/**
 * The following scripts get applied on the frontend of your site.
 */
jQuery(document).ready(function ($) {
    $('.slider').each(function(){
        $(this).slick();
    });
})